import Swiper from 'swiper';
import { whenElementReady } from '../../../../application/typescript/utils/utils';

class QuizzResultat {
  constructor() {
    this._init();
  }

  _init() {
    whenElementReady('.quizz-resultat__swiper', () => {
      new Swiper('.quizz-resultat__swiper', {
        direction: 'horizontal',
        slidesPerView: 1.2,
        spaceBetween: 20,
        grabCursor: true,
        mousewheel: true,
        preventInteractionOnTransition: true,
        breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: 24
          },
          1025: {
            slidesPerView: 4,
            spaceBetween: 32
          }
        }
      });
    });
  }
}

export const quizzResultat = new QuizzResultat();
